import { render, staticRenderFns } from "./CmgLeaveGroupOrderModal.vue?vue&type=template&id=b22a9780&scoped=true&lang=pug&"
import script from "./cmg-leave-group-order-modal.ts?vue&type=script&lang=ts&"
export * from "./cmg-leave-group-order-modal.ts?vue&type=script&lang=ts&"
import style0 from "./CmgLeaveGroupOrderModal.vue?vue&type=style&index=0&id=b22a9780&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22a9780",
  null
  
)

export default component.exports